import styled from "styled-components";

export const AuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 35%;
  min-width: 380px;
  width: 100%;

  h2 {
    margin: 10px 0;
  }
`;

export const AuthButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
